import { render } from "./CANDIDATE_VAL_IS_LOST.vue?vue&type=template&id=3e824c42"
import script from "./CANDIDATE_VAL_IS_LOST.vue?vue&type=script&lang=js"
export * from "./CANDIDATE_VAL_IS_LOST.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__